import React, { useLayoutEffect, useState } from 'react';
import styles from './FocalImageWrapper.module.css';
import {FocalImage} from 'lib/react-image-focus/FocalImage';
import {Image} from 'interfaces/models';

interface Props {
    image: Image,
    x: number,
    y: number,
    z: number
}

const FocalImageWrapper = ({image, x, y, z}: Props) => {
    let imageContainer: HTMLDivElement | null | undefined;
    const [height, setHeight] = useState(0);

    const getHeight = () => !imageContainer ? 0 : imageContainer.getBoundingClientRect().width * 0.5625;

    useLayoutEffect(() => {
        const updateHeight = () => setHeight(getHeight());
        window.addEventListener('resize', updateHeight);
        updateHeight();
        return () => window.removeEventListener('resize', updateHeight);
    });

    return <div className={styles.focalImageContainer} ref={el => (imageContainer = el)} style={{height}}>
        <FocalImage src={image.originalUrl} focalPoint={{x, y, z: z || 1}} />
    </div>;
}

export default FocalImageWrapper;